export const juneAbbreviatedLowercase = "Vqa";
export default {juneAbbreviatedLowercase};